import { inject, Injectable, signal } from '@angular/core';
import { Auth, onIdTokenChanged, User } from '@angular/fire/auth';
import { jwtDecode } from 'jwt-decode';

import { LogService } from './log.service';
@Injectable({ providedIn: 'root' })
export class AuthService {
	private auth = inject(Auth);
	public token = signal(null);

	constructor(private log: LogService) {
		onIdTokenChanged(this.auth, async (user: User | null) => {
			this.token.set(user ? await user.getIdToken() : null);
			this.log.debug('token:', this.token());
		});
	}

	setToken(token: string) {
		this.token.set(token);
	}

	async decodeToken(token: string, type: string): Promise<any | null> {
		try {
			const payload = jwtDecode<any>(token);
			this.log.debug('token payload', payload);
			if (payload?.type !== type) return null;
			return payload;
		} catch {
			return null;
		}
	}
}
